import script from "./ContentSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentSection.vue?vue&type=script&setup=true&lang=js"

import "./ContentSection.vue?vue&type=style&index=0&id=2e29805a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e29805a"]])

export default __exports__